"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdCategoryToJSON = exports.AdCategoryFromJSONTyped = exports.AdCategoryFromJSON = exports.instanceOfAdCategory = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the AdCategory interface.
 */
function instanceOfAdCategory(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdCategory = instanceOfAdCategory;
function AdCategoryFromJSON(json) {
    return AdCategoryFromJSONTyped(json, false);
}
exports.AdCategoryFromJSON = AdCategoryFromJSON;
function AdCategoryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'parentCategory': !(0, runtime_1.exists)(json, 'parent_category') ? undefined : json['parent_category'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
    };
}
exports.AdCategoryFromJSONTyped = AdCategoryFromJSONTyped;
function AdCategoryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'parent_category': value.parentCategory,
        'name': value.name,
    };
}
exports.AdCategoryToJSON = AdCategoryToJSON;
